var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 10,
  cy: 10,
  r: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8",
  fill: "#008BFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.874 5c-.31 0-.577.103-.8.309a.977.977 0 0 0-.333.742c0 .29.111.537.334.74.222.204.488.306.799.306.31 0 .575-.102.796-.306a.97.97 0 0 0 .33-.74.98.98 0 0 0-.33-.742A1.125 1.125 0 0 0 10.874 5Zm.3 8.195c-.245 0-.418-.04-.517-.12-.1-.08-.15-.23-.15-.452 0-.088.016-.217.047-.389a4.53 4.53 0 0 1 .103-.457l.473-1.663c.046-.152.078-.32.095-.502.017-.183.026-.31.026-.383 0-.35-.124-.635-.371-.855-.248-.219-.6-.328-1.056-.328a2.68 2.68 0 0 0-.806.134c-.284.09-.58.197-.892.323L8 9.017a5.23 5.23 0 0 1 .332-.108c.128-.039.254-.057.377-.057.25 0 .418.042.507.125.088.084.133.233.133.446 0 .118-.015.249-.044.391a7.794 7.794 0 0 1-.106.455l-.475 1.668a4.719 4.719 0 0 0-.092.472c-.019.139-.029.275-.029.408 0 .343.128.626.382.85.256.222.613.333 1.073.333.298 0 .56-.039.787-.117.226-.078.529-.192.908-.34l.126-.514c-.065.03-.17.065-.315.106-.146.04-.276.06-.39.06Z",
  fill: "#008BFF"
}))));
export { SvgIcoInfo as ReactComponent };
export default __webpack_public_path__ + "assets/media/ico-info.c23c63b77313804cb27c849f6051db75.svg";